import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        Telif Hakkı: Tüm hakları saklıdır. Bu proje, Ali AĞCA tarafından
        geliştirilmiştir. İzinsiz kopyalanamaz ve paylaşılamaz.
      </p>
      <p className="made-by">made by Ali AĞCA</p>
    </footer>
  );
}
